import React from 'react';
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {useHistory} from "react-router-dom";
import {AUTH_SUCCESSFUL} from "../store/action";
import GoogleAuth from './GoogleAuth';
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100vh',
        display: 'flex',
        paddingTop: theme.spacing(10),
        // alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
    },
    container: {
        maxWidth: 400,
        width: '100%',
    },
    paper: {
        padding: theme.spacing(4),
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: theme.shadows[3],
    },
    title: {
        marginBottom: theme.spacing(4),
        textAlign: 'center',
        color: theme.palette.primary.main,
        fontWeight: 600,
    },
    subtitle: {
        marginBottom: theme.spacing(4),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    authContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    divider: {
        margin: theme.spacing(3, 0),
        '&::before, &::after': {
            borderColor: theme.palette.divider,
        },
    },
    dividerText: {
        color: theme.palette.text.secondary,
        padding: theme.spacing(0, 2),
    },
}));

const LoginPage = ({dispatch}) => {
    const classes = useStyles();
    const {t} = useTranslation()
    const history = useHistory();
    const handleLogin = ({authToken}) => {
        dispatch({type: AUTH_SUCCESSFUL, payload: authToken})
        history.push("/calendar")
    }
    return <Box className={classes.root}>
        <Container className={classes.container}>
            <Paper className={classes.paper}>
                <Typography variant="h4" component="h1" className={classes.title}>
                    {t('app_name')}
                </Typography>
                <Typography variant="subtitle1" className={classes.subtitle}>
                    {t('login')}
                </Typography>
                
                <Box className={classes.authContainer}>
                    <GoogleAuth onFinish={handleLogin}/>
                    {/* <Divider className={classes.divider}>
                        <Typography variant="body2" className={classes.dividerText}>
                            {t('or')}
                        </Typography>
                    </Divider> */}
                    {/* <FacebookAuth 
                        title={t('login')}
                        onFinish={handleLogin}
                    /> */}
                </Box>
            </Paper>
        </Container>
    </Box>
}

export default connect()(LoginPage);